// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';

// Section for type definition -----------------------------------------------------------------------------------------
type SelectedLines = number[] | [];
const initSelectedLines: SelectedLines = [];

export const SelectedLinesContext: React.Context<SelectedLines> = createContext<SelectedLines>(initSelectedLines);
export const UpdateSelectedLines: React.Context<any> = createContext(initSelectedLines);
// export const SelectedLinesConsumer = SelectedLinesContext.Consumer;
export const useSelectedLines = () => useContext(SelectedLinesContext);
export const useUpdateSelectedLines = () => useContext(UpdateSelectedLines);

// Section for render component ----------------------------------------------------------------------------------------
function SelectedLinesProvider(props: any): React.JSX.Element {
  const { children } = props;
  const [selectedLines, setSelectedLines] = useState(initSelectedLines);
  // valueにグローバルに扱う値を設定

  return (
    <SelectedLinesContext.Provider value={selectedLines}>
      <UpdateSelectedLines.Provider value={setSelectedLines}>{children}</UpdateSelectedLines.Provider>
    </SelectedLinesContext.Provider>
  );
}

export default SelectedLinesProvider;
